import { ReactComponent } from "./btn_add.svg";
import styled from "styled-components";

const StyledIcon = styled(ReactComponent)`
  cursor: pointer;
`;

const AddIcon = () => <StyledIcon />;

export default AddIcon;
